
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/skisted",
      function () {
        return require("private-next-pages/skisted.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/skisted"])
      });
    }
  